module.exports = "images/doc-day-add.66a39780e32be2d940632336c1103f05.png";